import { graphql, useStaticQuery } from 'gatsby';

import {AllAnalysisQuery} from "../../generated/types/gatsby";

export const useAnalysis = () => {
  return useStaticQuery<AllAnalysisQuery>(graphql`
    query allAnalysis {
      allDrupalContentAnalysis {
        nodes {
          analysisName
          analysisExternal
          path
          id
          synonymsKeyWords
        }
      }
    }
  `);
};
